module.exports = tribe.common.hoc;